
import * as React from 'react';
import { Dialog, DialogFooter, IDialogProps } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton, IButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import strings from './ConfirmationDialog.resx';

/**
 * @internal
 */
export type IConfirmationDialogProps = {
  title: string;
  prompt: React.ReactNode;
  yesText?: React.ReactNode;
  noText?: React.ReactNode;
  defaultToYes?: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
} & Pick<IDialogProps, 'maxWidth'>;

/**
 * @internal
 */
export const ConfirmationDialog: React.StatelessComponent<IConfirmationDialogProps> = (props: IConfirmationDialogProps) => {
  const {
    onConfirm,
    onCancel,
    defaultToYes = false,
    yesText = strings.yes,
    noText = strings.no
  } = props;

  const onNoRef = (button: IButton | null) => {
    if (button) {
      button.focus();
    }
  };

  const YesButton = defaultToYes ? PrimaryButton : DefaultButton;
  const NoButton = defaultToYes ? DefaultButton : PrimaryButton;

  return (
    <Dialog
      onDismiss={ onCancel }
      isOpen={ true }
      title={ props.title }
      maxWidth={ props.maxWidth }
    >
      <Label>{ props.prompt }</Label>
      <DialogFooter>
        <YesButton
          data-automationid='confirmbutton'
          onClick={ onConfirm }
        >
          { yesText }
        </YesButton>
        <NoButton
          data-automationid='cancelbutton'
          onClick={ onCancel }
          componentRef={ onNoRef }
        >
          { noText }
        </NoButton>
      </DialogFooter>
    </Dialog>
  );
};
